import React from 'react';
import Preloader from 'ati-ui-react/components/Preloader';

import { ReportLoaderContainer } from './ReportLoaderStyles';
import { Table } from '../../FullVinReportStyles';

const ReportLoader = () => {
  return (
    <Table>
      <tbody>
        <tr>
          <td>
            <ReportLoaderContainer>
              <div>
                <Preloader small />
              </div>
              <span>
                Получение данных может занять некоторое время. Попробуйте посмотреть отчет позднее
              </span>
            </ReportLoaderContainer>
          </td>
        </tr>
      </tbody>
    </Table>
  );
};

export default ReportLoader;
